<template lang="pug">
div
    i.fa.fa-spinner.fa-spin
</template>

<script>
export default {
  name: 'Component_Loading'
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// Component_Loading.vue?1c622f4c